import React from "react";
import Button from "../../component/Button/Button";
import VouchersBox from "../../component/VouchersBox/VouchersBox";
import Footer from "../../footer/footer";
import Header from "../../Header/Header";
import "./VouchersCoupons.css";

const voucher_text = [
  {
    voucher_tile: "My Favourites",
    route: "/favourite-list",
  },
  {
    voucher_tile: "Special Promotions",
    route: "/special-promotions",
  },
  {
    voucher_tile: "My 360 Pass Coupons",
    route: "/my-pass-coupons",
  },
  // {
  //   voucher_tile: "Voucher or Coupon Name",
  // },
  // {
  //   voucher_tile: "Voucher or Coupon Name",
  // },
  // {
  //   voucher_tile: "Voucher or Coupon Name",
  // },
  // {
  //   voucher_tile: "Voucher or Coupon Name",
  // },
  // {
  //   voucher_tile: "Voucher or Coupon Name",
  // },
  // {
  //   voucher_tile: "Voucher or Coupon Name",
  // },
  // {
  //   voucher_tile: "Voucher or Coupon Name",
  // },
];
const VouchersCoupons = (props) => {
  return (
    <>
      <div className="bg_body">
        <Header />
        <div className="inner_pg">
          <div className="voucherscoupons">
            <div className="container">
              <div className="row">
                <div className="col-md-8 offset-md-2">
                  <h1 className="top_heading">Vouchers and Coupons</h1>
                  <div className="row">
                    {voucher_text.map((item) => (
                      <VouchersBox
                        title={item.voucher_tile}
                        route={item.route}
                      />
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
};

export default VouchersCoupons;
